module.exports = __webpack_public_path__ + "img/cabinet_online.98ef2224.svg";